'use client'

import { useEffect } from 'react'

/*
    INFO: bfCache should not work for internal navigation, but because our website is always fully refreshed browser bfCache treat this route as initial external route and serve it from cache.
    That makes our nextjs and browser router inconsistent which results in blocked navigation.
    TODO: remove when we resolve the issue with constantly fully refreshed pages.
 */
export function DisableBfCache() {
  useEffect(() => {
    const reloadAfterBfCache = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload()
      }
    }

    window.addEventListener('pageshow', reloadAfterBfCache)

    return () => {
      window.removeEventListener('pageshow', reloadAfterBfCache)
    }
  }, [])

  return null
}
